function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function getHostname() {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
}
function getDomainWithoutSubdomain() {
  const hostname = getHostname();
  if (!hostname) {
    return;
  }
  if (hostname === 'localhost') return hostname;
  const _hostname$split = hostname.split('.'),
    _hostname$split2 = _toArray(_hostname$split),
    domain = _hostname$split2.slice(1);
  return `.${domain.join('.')}`;
}
export { getDomainWithoutSubdomain, getHostname };
//# sourceMappingURL=getDomain.js.map
